var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("a-loading-secondary " + _vm.loadingClass)},[_c('img',{attrs:{"alt":"loading","src":require("@/assets/loading/loading-animation.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }